import { Button, IconButton, Tooltip } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { DragDropContext, Draggable, Droppable } from '@react-forked/dnd';
import { useRecoilState, useRecoilValue } from 'recoil';
import { multiPanelAtom, panelSettingAtom, panelStartIndexAtom } from '@/state/atom/panelAtom';
import Constant from '@/common/constant/Constant';
import {
    getListFieldCanAddToForm,
    onBeforeDragStartHandler,
    onDragEndHandler,
    onSubmitEditForm,
    setExpandMoreField,
    updatelistFieldAddToForm,
    onChangeItemInForm,
    validateErrorAddFieldToForm,
    getListFieldInForm,
    updateShareFormToField,
    isDisplaySplitPDF,
    isDisplaySettingSynonymSearch,
    onChangeSettingSynonym,
    isDisplayPinIconActiveFieldToForm,
    handleHiddenSysField,
    isDisplayPinIconInactiveFormToField,
    updateFieldCreateNewToFieldAddToForm,
    getInvalidSysFields
} from './handler/FormListHandler';
import {
    getProjectNameOfField,
    isProjectUsingSystemForm,
} from '@/component/formManagement/handler/FieldListHandler';
import {
    addFieldNew,
    closePanelFormManagement,
    getAddFieldByFieldType,
    getIconFieldByTypeField,
    isUseFieldInForm,
    sortFieldListByOrder,
    validateFieldList
} from '@/component/formManagement/handler/CommonHandler';
import './FormManagement.css';
import { userAtom } from '@/state/atom/userAtom';
import { projectInuseDetailAtom, projectListInCorporationAtom } from '@/state/atom/projectAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import Utils from '@/common/utils/utils';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import CreateFormSchema from '@/schema/CreateFormSchema';
import FormInput from '../common/form/input';
import { formListOfProjectSelector, fieldListOfProjectSelector } from '@/state/selector/formSelector' ;
import LoadingIndicator from '../common/LoadingIndicator';

import './FieldList.css';
import systemField, {TmpHiddenSystemField, ForceActiveSystemFields} from '@/common/constant/SystemField';
import AddFieldTagItem from './addField/AddFieldTagItem';
import AddFieldStatusItem from './addField/AddFieldStatusItem';
import MoreActionField from './MoreActionField';
import { I18n } from 'aws-amplify';
import { useSnackbar } from 'notistack';
import { HasExpandSysField } from '../../common/constant/SystemField';
import ShareForm from './ShareForm';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { cloneDeep } from 'lodash';
import SettingTitleForm from './SettingTitleForm';
import SettingChatPermissionForm from './SettingChatPermissionForm';
import SettingEditPermissionForm from './SettingEditPermissionForm';
import SettingViewPermissionForm from './SettingViewPermissionForm';
import { getFieldListInForm } from '@/service/formManagementService';
import DataChangePleaseReloadModal from '../common/modal/DataChangePleaseReloadModal';
import UnsavedChangesDialog from './UnsavedChangesDialog';
import { formPanelTabCloseManagementAtom } from '@/state/atom/formAtom';

export default function EditFormDev(props) {
    const formEdit = props.formEdit;
    const  structure= Utils.convertJSONDataToObject(formEdit.structure)
    const isDuplicateForm = props.isDuplicateForm;
    const [isLoading, setIsLoading] = useState(false);
    const [settingSlideRecoilState, setSettingSlideRecoilState] = useRecoilState(panelSettingAtom);
    // common userDetail state
    const userDetail = useRecoilValue(userAtom);
    // common projectInuse state
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);
    // common fieldList state
    const [fieldListInState, setFieldListInState] = useRecoilState(fieldListOfProjectSelector);
    
    // manager edited state form, field screen, close panel atom 
    const [formPanelTabClose, setFormPanelTabClose] = useRecoilState(formPanelTabCloseManagementAtom);

    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [currentIndex, setCurrentIndex] = useRecoilState(panelStartIndexAtom);

    // fieldType popover
    const [fieldTypePopover, setFieldTypePopover] = useState(null);
    const isOpenFieldTypePopover = Boolean(fieldTypePopover);
    const id = isOpenFieldTypePopover ? 'simple-popover_form' : undefined;
    const [fieldList, setFieldList] = useState([]);
    const [fieldAddList, setFieldAddList] = useState(!Utils.isEmptyArray(formEdit.defaultFieldAddList) ? cloneDeep(formEdit.defaultFieldAddList) : []);
    const [currentAddField, setCurrentAddField] = useState({});

    // system field list
    const [systemFieldList, setSystemFieldList] = useState(systemField);

    // fieldType
    const [fieldTypeSelectedList, setFieldTypeSelectedList] = useState([]);

    const [currentUpdateField, setCurrentUpdateField] = useState({});
    const [parentPanelScreen, setParentPanelScreen] = useState(
        Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM
    );
    const [panelScreen, setPanelScreen] = useState(Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM);
    const [regionDropIdBlock, setRegionDropIdBlock] = useState('');

    const projectList = useRecoilValue(projectListInCorporationAtom);

    const methods = useForm({
        mode: 'all',
        resolver: yupResolver(CreateFormSchema)
    });

    const { handleSubmit, errors } = methods;

    const [formName, setFormName] = useState(Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, formEdit.name));
    const onChangeFormName = e => {
        let nameForm = e.target.value;
        setFormName(nameForm);
        setIsChangeData(true);
    };
    const [listFieldAddToForm, setListFieldAddToForm] = useState([]);
    const [listFieldInProject, setListFieldInProject] = useState([]);

    const { enqueueSnackbar } = useSnackbar();
    const [isChangeData, setIsChangeData] = useState(false);

    useEffect(() => {
        setFieldList(listFieldAddToForm);
    }, [listFieldAddToForm]);

    useEffect(() => {
        updatelistFieldAddToForm(argsAll);
    }, [fieldList]);

    useEffect(() => {
        const checkUpdateResult = updateFieldCreateNewToFieldAddToForm(fieldAddList,listFieldAddToForm);
        if(checkUpdateResult?.isChange){
            setListFieldAddToForm([...checkUpdateResult.fieldAddToForm])
            // setListFieldAddToForm(handleHiddenSysField([...checkUpdateResult.fieldAddToForm], props.formEdit.type))
        }
    },[fieldAddList])

    // common form
    // const formList = useRecoilValue(formListOfProjectSelector);
    const [formList, setFormList] = useRecoilState(formListOfProjectSelector);
    const isUsingSystemFormInvite = isProjectUsingSystemForm(formList);
    const isUsingSystemFormQA = isProjectUsingSystemForm(formList, Constant.FORM_TYPE.FORM_REQ_QA);
    const isUsingSystemFormExternalDeskRequest = isProjectUsingSystemForm(
        formList,
        Constant.FORM_TYPE.FORM_REQ_EXTERNAL_DESK
    );
    const isUsingSystemFormCustomerInvite = isProjectUsingSystemForm(
        formList,
        Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST_CUSTOMER
    );
    const isUsingSystemFormExternalCustomerRequest = isProjectUsingSystemForm(
        formList,
        Constant.FORM_TYPE.FORM_REQ_EXTERNAL_CUSTOMER
    );


    const [confirmDialogObj, setConfirmDialogObj] = useState({open: false, msg: ''});
    const [shareOptionValue, setShareOptionValue] = useState(0);
    const [shareDestination, setShareDestination] = useState([]);
    const [isShowSettingTitle, setIsShowSettingTitle] = useState(false);
    const [settingTitle, setSettingTitle] = useState([]);

    const [selectedViewPermissions, setSelectedViewPermissions] = useState([]);
    const [selectedEditPermissions, setSelectedEditPermissions] = useState([]);
    const [selectedChatPermissions, setSelectedChatPermissions] = useState('');
    const [isViewPermissionSelected, setIsViewPermissionSelected] = useState(false);

    const [titleLineNumber, setSettingTitleLineNumber] = useState(structure?.titleLineNumber);
    const [isHasSettingTitle, setIsHasSettingTitle] = useState(true);
    const [settingMasterKnowledge,setSettingMasterKnowledge] = useState(formEdit.type === Constant.FORM_TYPE.FORM_MASTER ? 1 : 0);
    const [settingReviewFlag, setSettingReviewFlag] = useState(formEdit.reviewFlag);

    const [createTicketForOwnerBasePermission,setCreateTicketForOwnerBasePermission] = useState([]);
    const [additionalCreateTicketForOwnerPermission,setAdditionalCreateTicketForOwnerPermission] = useState([])
    const [isFormReadOnly, setIsFormReadOnly] = useState(false);
    
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    // selectable drop list of chat permission
    const [listOptionChatPermission, setListOptionChatPermission] = useState([]);
    const [splitPdf, setSplitPdf] = useState(structure?.splitPdf);
    const [isSynonym, setIsSynonym] = useState(formEdit.isSynonym ? true : false);
    const [isAllowCustomerChangeStatus, setIsAllowCustomerChangeStatus] = useState(formEdit.isAllowCustomerChangeStatus ? true : false);

    const argsAll = {
        enqueueSnackbar: enqueueSnackbar,

        isDuplicateForm: isDuplicateForm,

        listFieldAddToForm: listFieldAddToForm,
        setListFieldAddToForm: setListFieldAddToForm,
        listFieldInProject: listFieldInProject,
        setListFieldInProject: setListFieldInProject,

        formList: formList,
        setFormList: setFormList,
        addFormType: formEdit.type,
        API: props?.API,
        formEdit: formEdit,
        listForm: props.listForm,
        settingSlideRecoilState: settingSlideRecoilState,
        fieldListInState: fieldListInState,
        corporationDetail: corporationDetail,
        corporationId: corporationDetail.id,
        projectInuseId: projectInuseDetail.id,
        projectDetail: projectInuseDetail,
        projectList: projectList,
        userId: userDetail.id,
        userDetail: userDetail,
        isUsingSystemFormInvite: isUsingSystemFormInvite,
        isUsingSystemFormQA: isUsingSystemFormQA,
        isUsingSystemFormExternalDeskRequest: isUsingSystemFormExternalDeskRequest,
        isUsingSystemFormCustomerInvite: isUsingSystemFormCustomerInvite,
        isUsingSystemFormExternalCustomerRequest,
        currentAddField: currentAddField,

        setOpenScreen: props.setOpenScreen,
        setIsLoading: setIsLoading,
        setSettingSlideRecoilState: setSettingSlideRecoilState,
        setFieldListInState: setFieldListInState,
        setListForm: props.setListForm,
        setCurrentAddField: setCurrentAddField,

        // field list
        fieldList: fieldList,
        setFieldList: setFieldList,

        systemFieldList: systemFieldList,
        setSystemFieldList: setSystemFieldList,

        fieldTypeSelectedList: fieldTypeSelectedList,
        setFieldTypeSelectedList: setFieldTypeSelectedList,

        fieldAddList: fieldAddList,
        setFieldAddList: setFieldAddList,

        currentUpdateField: currentUpdateField,
        setCurrentUpdateField: setCurrentUpdateField,

        panelScreen: panelScreen,
        setPanelScreen: setPanelScreen,

        parentPanelScreen: parentPanelScreen,
        setParentPanelScreen: setParentPanelScreen,

        regionDropIdBlock: regionDropIdBlock,
        setRegionDropIdBlock: setRegionDropIdBlock,

        setIsChangeData: setIsChangeData,
        isChangeData: isChangeData,

        allListCorp: props.allListCorp,
        b2bCustomerList: props.b2bCustomerList,
        b2bHelpDeskList: props.b2bHelpDeskList,

        confirmDialogObj: confirmDialogObj,
        setConfirmDialogObj: setConfirmDialogObj,

        shareOptionValue: shareOptionValue,
        setShareOptionValue: setShareOptionValue,
        
        shareDestination: shareDestination,
        setShareDestination: setShareDestination,
        settingTitle :settingTitle ,
        setSettingTitle : setSettingTitle,
        titleLineNumber : titleLineNumber, 
        setSettingTitleLineNumber: setSettingTitleLineNumber,
        settingMasterKnowledge,
        settingReviewFlag,
        splitPdf, 
        setSplitPdf,

        selectedViewPermissions,
        setSelectedViewPermissions,
        selectedEditPermissions,
        setSelectedEditPermissions,
        selectedChatPermissions,
        setSelectedChatPermissions,
        isViewPermissionSelected,
        setIsViewPermissionSelected,
        createTicketForOwnerBasePermission,
        setCreateTicketForOwnerBasePermission,
        additionalCreateTicketForOwnerPermission,
        setAdditionalCreateTicketForOwnerPermission,
        isFormReadOnly,
        setIsFormReadOnly,

        isOpenModalReloadPage,
        setIsOpenModalReloadPage,
        listOptionChatPermission,
        setListOptionChatPermission,

        isSynonym,
        setIsSynonym,

        isDisplaySettingSynonymSearch,
        isAllowCustomerChangeStatus,
        setIsAllowCustomerChangeStatus,

        setFormPanelTabClose: setFormPanelTabClose,
        isOpenUnsavedChangesDialog: props?.isOpenUnsavedChangesDialog || false,
        setIsOpenUnsavedChangesDialog: props?.setIsOpenUnsavedChangesDialog ? props?.setIsOpenUnsavedChangesDialog : () => {},
        setTabSelected: props?.setTabSelected ? props?.setTabSelected : () => {},
        tabSelected: props?.tabSelected ? props?.tabSelected : Constant.TAB_FORM_MANAGEMENT.FORM,
    };

    const onClickCloseConfirmDialog = () => {
        setConfirmDialogObj({open: false, msg: ''})
    }

    const onClickOkConfirmDialog = () => {
        setConfirmDialogObj({open: false, msg: ''})
        updateShareFormToField(argsAll);
        onSubmitEditForm(formName, formEdit.type, argsAll, isSynonym)
    }

    useEffect(() => {
        if(!Utils.isEmptyObject(formEdit)) {
            if (formEdit.affiliationProject !== projectInuseDetail.id) {
                setIsFormReadOnly(true);
                setIsShowSettingTitle(true);
            }
        }
    }, [formEdit])

    useEffect(() => {
        prepareDataForListForm();
    }, [fieldListInState]);

    const prepareDataForListForm = async() => {
        let currentFormStructure = !Utils.isEmptyString(formEdit.structure)
            ? Utils.convertJSONDataToObject(formEdit.structure)
            : {};

        let fieldIdList = [];
        let fieldListInForm = [];
        if ((formEdit.affiliationProject !== projectInuseDetail.id || Utils.isEmptyArray(fieldListInState)) && !Utils.isEmptyObject(currentFormStructure)) {
            for (const fieldNumber in currentFormStructure) {
                if (currentFormStructure.hasOwnProperty(fieldNumber)) {
                    if (currentFormStructure[fieldNumber].hasOwnProperty('field')) {
                        fieldIdList.push(currentFormStructure[fieldNumber]['field']);
                    }
                }
            }
    
            if (Utils.isEmptyArray(fieldIdList)) {
                return [];
            }

            setIsLoading(true);
            fieldListInForm = await getFieldListInForm(
                props?.API,
                formEdit.affiliationOrganization,
                fieldIdList
            );
            setIsLoading(false);
        }

        //list field of form
        // let ForceActiveSystemFieldByFormType = getForceActiveSystemFieldByFormType(props.addFormType)
        let fieldInForm = [];
        if (formEdit.affiliationProject !== projectInuseDetail.id) {
            fieldInForm = getListFieldInForm(currentFormStructure, fieldListInForm);
        } else {
            fieldInForm = getListFieldInForm(currentFormStructure, !Utils.isEmptyArray(fieldListInState) ? fieldListInState : fieldListInForm);
        }

        fieldInForm = fieldInForm.filter(
            field =>
                !(
                    field.type === Constant.FORM_TYPE.FIELD_WORKFLOW &&
                    field.affiliationProject !== projectInuseDetail.id
                ) && !TmpHiddenSystemField.includes(field.sysField)
        );

        fieldInForm.forEach(field => {
            field.isUsingForm = true;
        });

        const isFormShareReadOnly = formEdit.affiliationProject !== projectInuseDetail.id;

        let listFieldShowInform = fieldInForm.filter(field => {
            if (formEdit.type === Constant.FORM_TYPE.FORM_KNOWLEDGE || formEdit.type === Constant.FORM_TYPE.FORM_MASTER) {
                if(field.definition === Constant.FORM_DEFINITION.SYSTEM) {
                    if(isFormShareReadOnly && field.publicForCustomer === Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW) {
                        return false;
                    }
                    return true;
                }
                
                if (field.publicForCustomer === Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW && field.affiliationProject !== projectInuseDetail.id) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        });

        const invalidSysFieldInForm = getInvalidSysFields(props.formEdit.type);
        listFieldShowInform = listFieldShowInform.filter(
            field => !invalidSysFieldInForm.includes(field.sysField)
        );

        setListFieldAddToForm(listFieldShowInform);
        // setListFieldAddToForm(handleHiddenSysField(listFieldShowInform, props.formEdit.type))

        //list field can add to form
        let fieldInProject = getListFieldCanAddToForm(argsAll, fieldInForm).filter(field => {
            let invalidSysField = []
            let isInvalid = false;

            switch (props.formEdit.type) {
                case Constant.FILTER_LIST_FORM_TYPE.FORM_REQ_QA:
                    invalidSysField = ['AIPromptBody', 'ApplyAIprompt', 'AIPromptApplicationTarget', 'listOfSynonyms', Constant.SYSTEM_FIELD.AI_BASIC_INFO_TRANSMISSION, Constant.SYSTEM_FIELD.AI_PDF_PAGE_SPLIT_STATUS]
                    break
                case Constant.FILTER_LIST_FORM_TYPE.FORM_TASK:
                    invalidSysField = ['proxiedUser', 'escalationOriginCustomer', 'escalationTarget', 'AIPromptBody', 'ApplyAIprompt', 'AIPromptApplicationTarget', 'listOfSynonyms', Constant.SYSTEM_FIELD.AI_BASIC_INFO_TRANSMISSION, Constant.SYSTEM_FIELD.AI_PDF_PAGE_SPLIT_STATUS]
                    break
                case Constant.FILTER_LIST_FORM_TYPE.FORM_KNOWLEDGE:
                case Constant.FILTER_LIST_FORM_TYPE.FORM_MASTER:
                    invalidSysField = ['proxiedUser', 'escalationOriginCustomer', 'escalationTarget', 'AIPromptBody', 'ApplyAIprompt', 'AIPromptApplicationTarget', Constant.SYSTEM_FIELD.AI_BASIC_INFO_TRANSMISSION, Constant.SYSTEM_FIELD.AI_PDF_PAGE_SPLIT_STATUS]
                    break;
                case Constant.FILTER_LIST_FORM_TYPE.FORM_REQ_NOTICE:
                    invalidSysField = ['proxiedUser', 'escalationOriginCustomer', 'escalationTarget', 'AIPromptBody', 'ApplyAIprompt', 'AIPromptApplicationTarget', 'listOfSynonyms', Constant.SYSTEM_FIELD.AI_BASIC_INFO_TRANSMISSION, Constant.SYSTEM_FIELD.AI_PDF_PAGE_SPLIT_STATUS]
                    break;
                default:
                    return true;
            }

            // hidden with
            if (field.type === Constant.FORM_TYPE.FIELD_WORKFLOW && props.formEdit.type !== Constant.FILTER_LIST_FORM_TYPE.FORM_REQ_QA) {
                isInvalid = true;
            }

            return !invalidSysField.includes(field.sysField) && !TmpHiddenSystemField.includes(field.sysField) && !isInvalid
        });

        fieldInProject = sortFieldListByOrder(fieldInProject, argsAll.projectDetail);
        setListFieldInProject(fieldInProject);
    }

    const isDisableButtonSubmit = () => {
        // validate add field list
        
        let isErrorFieldAddList = false;
        let fieldAddListValidateResult = validateFieldList(fieldAddList, isErrorFieldAddList);
        isErrorFieldAddList = fieldAddListValidateResult.isValidateError;

        // Check form name validation
        const isFormNameError =
            Utils.isEmptyString(formName) || formName.trim().length > Constant.MAX_LENGTH.FORM_NAME;

        if (
            validateErrorAddFieldToForm(argsAll, listFieldAddToForm) ||
            isFormNameError ||
            !isHasSettingTitle ||
            (!Utils.isEmptyString(formName) && isChangeData === false && !argsAll.isDuplicateForm) ||
            isErrorFieldAddList
        ) {
            return true;
        }

        return false;
    };

    // uef listen change data from AddFieldStatusItem Screen
    useEffect(() => {
        if (isChangeData) {
            setFormPanelTabClose(prev => ({...prev, isDirty: true}));
        }
    }, [isChangeData]);

    const getFormTypeName = () => {
        let formTypeName = '';
        switch (formEdit.type) {
            case Constant.FORM_TYPE.FORM_REQ_QA:
                formTypeName = I18n.get('FIELDFORMBTN007');
                break;
            case Constant.FORM_TYPE.FORM_REQ_NOTICE:
                formTypeName = 'お知らせ';
                break;
            case Constant.FORM_TYPE.FORM_TASK:
                formTypeName = I18n.get('FIELDFORMBTN009');
                break;
            case Constant.FORM_TYPE.FORM_KNOWLEDGE:
                formTypeName = I18n.get('FIELDFORMBTN010');
                break;
            case Constant.FORM_TYPE.FORM_MASTER:
                formTypeName = I18n.get('FIELDFORMBTN011');
                break;
            default:
                break;
        }
        return formTypeName
    };

    // get drag/drop list
    const getDragDropList = () => {
        let listFieldAddToFormClone = [...listFieldAddToForm];
        listFieldAddToFormClone = listFieldAddToFormClone?.filter((field)=>{
            const prefixId = Utils.getPrefixOfId(field.id);
            if(prefixId === 'dummy'){
                return true
            }
           return field?.usingProjects.includes(formEdit.affiliationProject)
        }
        );
        let dragDropList = Utils.isEmptyArray(listFieldAddToFormClone)
            ? []
            : listFieldAddToFormClone;
        const listIdFiledAddToForm = dragDropList?.map(field => field.id);
        const fieldTypeSelectedListClone = fieldTypeSelectedList?.filter(field => !listIdFiledAddToForm.includes(field.id));
        dragDropList = Utils.isEmptyArray(fieldTypeSelectedListClone)
            ? dragDropList
            : dragDropList.concat(fieldTypeSelectedListClone);
        return dragDropList;
    };

    const getForceActiveSystemFieldByFormType = () => {
        let ForceActiveSystemFieldByFormType = [...ForceActiveSystemFields]
        ForceActiveSystemFieldByFormType.push('outline');
        // switch (props.formEdit.type) {
        //     // case Constant.FILTER_LIST_FORM_TYPE.FORM_REQ_NOTICE:
        //     case Constant.FILTER_LIST_FORM_TYPE.FORM_KNOWLEDGE:
        //             ForceActiveSystemFieldByFormType = ForceActiveSystemFieldByFormType.filter(fieldName => (
        //                 !['personInCharge'].includes(fieldName)
        //             ))
        //         break;
        //     default:
        //         break;
        // }

        return ForceActiveSystemFieldByFormType
    }

    const getForceActiveSystemField = () => {
        let forceActiveSystemField = getForceActiveSystemFieldByFormType();
        // outline has inactive outline
        forceActiveSystemField = forceActiveSystemField.filter(sys => !['outline', 'attachments'].includes(sys));
        switch (props.formEdit.type) {
            case Constant.FILTER_LIST_FORM_TYPE.FORM_REQ_NOTICE:
                forceActiveSystemField = forceActiveSystemField.filter(sys => !['personInCharge'].includes(sys));
                break;
            case Constant.FILTER_LIST_FORM_TYPE.FORM_KNOWLEDGE:
            case Constant.FILTER_LIST_FORM_TYPE.FORM_MASTER:
                forceActiveSystemField = forceActiveSystemField.filter(sys =>
                    !['personInCharge', 'AIPromptBody', 'ApplyAIprompt', 'AIPromptApplicationTarget', 'listOfSynonyms'].includes(sys)
                );
                break;
            default:
                break;
        }
        return forceActiveSystemField;
    }

    const renderFieldListV2 = (field, index, regionDropId) => {

        let forceActiveSystemField = getForceActiveSystemField()

        return (
            <div className="fieldSetting-info">
                <div className="fieldSetting-thumb">
                    <img src={`${getIconFieldByTypeField(field)}`} alt="" />
                </div>
                <div className="fieldSetting-cmt">
                    <div className="fieldSetting-name">
                        <p className="fieldSetting-tlt">
                            {Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, field.name)}
                        </p>
                        <p className="fieldSetting-text">
                            {getProjectNameOfField(field, projectList)}
                        </p>
                    </div>
                    <div className="fieldSetting-autofill">
                        <p className="fieldSetting-text">
                            {/* {isSystemField(field) ? '自動入力' : ''} */}
                        </p>
                        <div className={field.definition === Constant.FORM_DEFINITION.SYSTEM 
                            || isUseFieldInForm(field, props.listForm, argsAll) 
                            ? "setting-field-in-form fieldSetting-item addNewForm-item" : "setting-field-in-form fieldSetting-item addNewForm-item background-color-usingForm"}
                        >
                            {isDisplayPinIconInactiveFormToField(field, isSynonym, forceActiveSystemField, regionDropId) && !isFormReadOnly && (
                                <IconButton
                                    className="itemTools"
                                    onClick={() => onChangeItemInForm(argsAll, field, regionDropId)}
                                >
                                    <img src="/assets/image/icon-pin.svg" alt="" />
                                </IconButton>
                            )}
                            {isDisplayPinIconActiveFieldToForm(regionDropId, field, isSynonym) && (
                                <IconButton
                                    className="itemTools"
                                    onClick={() => onChangeItemInForm(argsAll, field, regionDropId)}
                                >
                                    <img src="/assets/image/icon-pin-outline.svg" alt="" />
                                </IconButton>
                            )}
                            {
                                (
                                    (field.definition !== Constant.FORM_DEFINITION.SYSTEM ||
                                    HasExpandSysField.includes(field.sysField)) && !isFormReadOnly
                                ) && (
                                    <IconButton
                                        className={field.isShowInfo ? "itemTools itemTools-arrow" : "itemTools"}
                                        onClick={e => {
                                            if (regionDropId) {
                                                setExpandMoreField(argsAll, field, regionDropId);
                                            }
                                        }}
                                    >
                                        <img src="/assets/image/icon-arrow-accordion-gray.svg" alt="" />
                                    </IconButton>
                                )
                            }
                            {field.definition !== Constant.FORM_DEFINITION.SYSTEM && !isFormReadOnly && <MoreActionField argsAll={argsAll} field={field} regionDropId={regionDropId}/>}
                        </div>
                    </div>
                </div>
            </div>
        );
    };


    /** handler click field type selected */
    const onClickFieldTypeSelected = fieldType => {
        setFieldTypePopover(null);
        addFieldNew(fieldType, argsAll, {});
        setFormPanelTabClose(prev => ({...prev, isDirty: true}));
    };
    
    const onCancelEdit = () => {
        if (isFormReadOnly) {
            props.setOpenScreen(Constant.FORM_MANAGEMENT_SCREEN.LIST_FORM);
            return;
        }

        if (argsAll.isDuplicateForm || isChangeData) {
            setFormPanelTabClose(prev => ({
                ...prev,
                isDirty: true,
                isCloseScreen: true  // Set flag for 閉じる button
            }));
            props?.setIsOpenUnsavedChangesDialog(true);
        } else {
            if (isDuplicateForm && formEdit.isShared) {
                let cloneFieldListInState = cloneDeep(fieldListInState);
                cloneFieldListInState = cloneFieldListInState.filter(
                    field =>
                        ![
                            Constant.CLIENT_FIELD_TYPE.ADD_NEW_FIELD,
                            Constant.CLIENT_FIELD_TYPE.DUPLICATE_FIELD
                        ].includes(field.clientFieldType)
                );
                setFieldListInState(cloneFieldListInState);
            }
            setFormPanelTabClose(prev => ({...prev, isDirty: false, isCloseScreen: false}));
            props.setOpenScreen(Constant.FORM_MANAGEMENT_SCREEN.LIST_FORM);
            props.setIsDuplicateForm(false);
        }
    }


    const renderHeaderV2 = () => {
        return (
            <div className="headManage">
                <div className="headManage-top">
                    <h2 className="headManage-title">{getFormTypeName()}</h2>
                    <div className="headManage-tools">
                        <div className="headManage-btn">
                            <Button
                                className="btn-light btn-hg32"
                                variant="contained"
                                color="default"
                                onClick={() => {
                                    onCancelEdit();
                                }}
                            >
                                閉じる
                            </Button>
                            {!isFormReadOnly && 
                            <Button
                                className="btn-primary btn-hg32"
                                onClick={handleSubmit(data => {
                                    setFormPanelTabClose(prev => ({...prev, isDirty: false}));
                                    
                                    if (isDuplicateForm && formEdit.isShared) {
                                        updateShareFormToField(argsAll);
                                    }
                                    onSubmitEditForm(data.name, formEdit.type, argsAll, isSynonym);
                                })}
                                disabled={isDisableButtonSubmit()}
                            >
                                保存
                            </Button>}
                        </div>
                    </div>
                </div>
                {/* headManage-top */}
                <FormProvider {...methods}>
                    <div>
                        <FormInput
                            name="name"
                            className="form-control-wrapInput form-control-hg40 setting-title-field-head"
                            variant="outlined"
                            defaultValue={formName}
                            value={formName}
                            required={true}
                            errorlist={errors}
                            onKeyUp={onChangeFormName}
                            placeholder="フォーマット名"
                            disabled={isFormReadOnly}
                        />
                        <div className="setting-form-id">
                            {I18n.get('CM-LABEL-FORMAT-ID')} :
                            <span
                                className="id-detail-ticket-copy"
                                onClick={async () => {
                                    navigator.clipboard
                                        .writeText(formEdit?.id)
                                        .then(() => {})
                                        .catch(err => {});
                                }}
                            >
                                <img src="/assets/image/icon-copy.svg" alt="" />
                            </span>
                            <span>{formEdit?.id}</span>
                        </div>
                    </div>
                    {/* formatName */}
                </FormProvider>
                <ConfirmDialog
                    isOpen={confirmDialogObj.open}
                    msgConfirm={confirmDialogObj?.msg}
                    closeCallBack={onClickCloseConfirmDialog}
                    okCallBack={onClickOkConfirmDialog}
                />
                <DataChangePleaseReloadModal {...argsAll} isOpen={isOpenModalReloadPage} setIsOpen={setIsOpenModalReloadPage}/>
                {/* addField */}
            </div>
        );
    };

    useEffect(() => {
        let isCancel = false;
        if (!Utils.isEmptyArray(fieldAddList) || !Utils.isEmptyString(formName)) {
            isCancel = true;
        } else {
            isCancel = false;
        }
        props.parentCallback(isCancel);
    }, [fieldAddList, formName]);

    const handleOnclickListField = id => {
        if(isFormReadOnly) return;

        const addFieldMenuElement = document.getElementById(id);
        const classNameOfElement = addFieldMenuElement.className;
        if (classNameOfElement === 'accordionForm accordionForm--show') {
            document.getElementById(id).classList.remove('accordionForm--show')
        } else if (classNameOfElement === 'accordionForm') {
            document.getElementById(id).classList.add('accordionForm--show');
        }
    };

    const onClickAddField = e => {
        const addFieldMenuElement = document.getElementById('addField-menu');
        const classNameOfElement = addFieldMenuElement.className;
        if (classNameOfElement === 'addField addField--show') {
            document.getElementById('addField-menu').classList.remove('addField--show');
        } else if (classNameOfElement === 'addField') {
            document.getElementById('addField-menu').classList.add('addField--show');
        }
    };

    const sortListFieldInProject = (listField) => {
        let listFieldSystem = [];
        let listFieldProjectSystem = [];
        let listFieldCustom = [];
        for (let i = 0; i < listField.length; i++) {
            const element = listField[i];
            if (element.definition === Constant.FORM_DEFINITION.SYSTEM) {
                listFieldSystem.push(element);
                continue;
            }
            if (element.type === Constant.FORM_TYPE.FIELD_WORKFLOW) {
                listFieldProjectSystem.push(element);
                continue;
            }
            listFieldCustom.push(element);
        }

        let newListField = [...listFieldSystem, ...listFieldProjectSystem, ...listFieldCustom];
        return newListField;
    }

    return (
        <>
            {panelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM && (
                <div className="groupManage">
                    <LoadingIndicator isLoading={isLoading} />
                    {renderHeaderV2()}
                    <div className="contentManage">
                    <div
                        className= {isFormReadOnly ? "accordionHead-SettingTitle pointer-default" : "accordionHead-SettingTitle"}
                        onClick={() => {
                            if(!isFormReadOnly) setIsShowSettingTitle(prev => !prev)
                        }}
                    >
                        <img src="/assets/image/setting-title.svg" alt="setting-title" />
                        <span className="text">詳細設定</span>
                        {
                            isShowSettingTitle ? (
                                <img src="/static/media/icon-minus-accordion.24e40269.svg" alt="minus"/>
                            ) : (
                                <img src="/static/media/icon-plus-accordion.d9a73563.svg" alt="plus" />
                            )
                        }
                    </div>
                {(formEdit.type === Constant.FORM_TYPE.FORM_KNOWLEDGE || formEdit.type === Constant.FORM_TYPE.FORM_MASTER) && <div className={`${isShowSettingTitle ? 'formatName-block' : 'formatName-none'}`}>
                    <div className='title'>■ マスターナレッジ設定</div>
                    <div className='setting-title-bottom'>
                        <span>マスターとして使用する　</span>
                        <div className="switch-check">
                            <input 
                                id="マスターとして使用する"
                                type="checkbox"
                                defaultChecked={settingMasterKnowledge === 1}
                                onChange={(e) => {setSettingMasterKnowledge(e.target.checked ? 1 : 0);setIsChangeData(true)}}
                                disabled={isFormReadOnly}
                            />
                            <label htmlFor='マスターとして使用する'></label>
                        </div>
                    </div>
                </div> }
                
                {isDisplaySettingSynonymSearch(corporationDetail, formEdit.type, projectInuseDetail, formEdit) && 
                    <div className={`${isShowSettingTitle ? 'formatName-block' : 'formatName-none'}`}>
                        <Tooltip title={I18n.get('MSG-FORM-USE-AS-SYNONYM-FORM-IF-INCLUDE-LIST-OF-SYNONYMS-FIELD')} arrow= {true} placement="top-center">
                            <div className='title'>{I18n.get('LABEL-SYNONYM-KNOW-SETTINGS')}</div>
                        </Tooltip>
                        <Tooltip title={I18n.get('MSG-FORM-USE-AS-SYNONYM-FORM-IF-INCLUDE-LIST-OF-SYNONYMS-FIELD')} arrow= {true} placement="top-center">
                            <div className='setting-title-bottom'>
                                <span>{I18n.get('LABEL-USE-AS-SYNONYM-KNOW')}</span>
                                <div className="switch-check">
                                    <input 
                                        id="setting-isSynonym"
                                        type="checkbox"
                                        defaultChecked={isSynonym}
                                            onChange={(e) => {onChangeSettingSynonym(e, setIsSynonym, setIsChangeData, argsAll)}  
                                        }
                                        disabled={isFormReadOnly}
                                    />
                                    <label htmlFor='setting-isSynonym'></label>
                                </div>
                            </div>
                        </Tooltip>
                    </div> 
                }

                {/* {(formEdit.type === Constant.FORM_TYPE.FORM_KNOWLEDGE || formEdit.type === Constant.FORM_TYPE.FORM_MASTER) && <div className={`${isShowSettingTitle ? 'formatName-block' : 'formatName-none'}`}>
                    <div className='title'>■ 公開承認設定</div>
                    <div className='setting-title-bottom'>
                        <span>公開承認フォーマットとして使用する　</span>
                        <div className="switch-check">
                            <input 
                                id="公開承認フォーマットとして使用する　"
                                type="checkbox"
                                defaultChecked={settingReviewFlag}
                                onChange={(e) => {setSettingReviewFlag(e.target.checked ? true : false); setIsChangeData(true)}}
                                disabled={isFormReadOnly}
                            />
                            <label htmlFor='公開承認フォーマットとして使用する　'></label>
                        </div>
                    </div>
                </div> } */}
                <div className={`${isShowSettingTitle ? 'formatName-block' : 'formatName-none'}`}>
                    <div className='title'>■ タイトル設定</div>
                    <SettingTitleForm
                        listFieldActiveOfForm={[...getDragDropList()]}
                        setIsHasSettingTitle = {setIsHasSettingTitle}
                        argsAll={argsAll}
                    />
                    <div className='setting-title-bottom'>
                        <span>全行数の表示</span>
                        <div className="switch-check">
                            <input 
                                id="全行数の表示"
                                type="checkbox"
                                defaultChecked={titleLineNumber === 2}
                                onChange={(e) => {setSettingTitleLineNumber(e.target.checked ? 2 : 0);setIsChangeData(true)}}
                                disabled={isFormReadOnly}
                            />
                            <label htmlFor='全行数の表示'></label>
                        </div>
                    </div>
                </div>
                
                {corporationDetail?.rootFlag === Constant.ROOT_FLAG.TRUE && 
                    <div className={`${isShowSettingTitle ? 'formatName-block' : 'formatName-none'}`}>
                        <div className='title'>■ 共有設定</div>
                        <ShareForm props={props} argsAll={argsAll} />
                    </div>
                }

                {(formEdit.type === Constant.FORM_TYPE.FORM_KNOWLEDGE || formEdit.type === Constant.FORM_TYPE.FORM_MASTER) && (
                    <>
                        {/* 投稿権限設定 - Hidden: feature not working, hide until further notice */}
                        {/* <div className={`${isShowSettingTitle ? 'formatName-block' : 'formatName-none'}`}>
                            <div className='title'>■ 投稿権限設定</div>
                            <SettingCreateTicketForOwnerPermission props={props} argsAll={argsAll} />
                        </div> */}
                        <div
                            className={`${
                                isShowSettingTitle ? 'formatName-block' : 'formatName-none'
                            }`}
                        >
                            <div className="title">
                                ■ ナレッジチケットの閲覧権限・編集権限設定
                            </div>
                            <SettingViewPermissionForm
                                props={props}
                                argsAll={argsAll}
                            />
                            <SettingEditPermissionForm
                                props={props}
                                argsAll={argsAll}
                            />
                        </div>
                        <div
                            className={`${
                                isShowSettingTitle ? 'formatName-block' : 'formatName-none'
                            }`}
                        >
                            <div className="title">
                                ■ チャットの閲覧・書き込み権限設定
                            </div>
                            <SettingChatPermissionForm
                                props={props}
                                argsAll={argsAll}
                            />
                        </div>
                        {isDisplaySplitPDF(corporationDetail, formEdit.type) && <div className={`${isShowSettingTitle ? 'formatName-block' : 'formatName-none'}`}>
                            <div className='title'>■ 添付ファイル デフォルト設定</div>
                            <div className='setting-title-bottom'>
                                <span>{I18n.get("LABEL-SPLIT-PDF-INTO-PAGES")}</span>
                                <div className="switch-check">
                                    <input 
                                        id="pdf_split"
                                        type="checkbox"
                                        defaultChecked={Boolean(splitPdf)}
                                        disabled={isFormReadOnly}
                                        onChange={(e) => {setSplitPdf(e.target.checked ? Constant.SPLIT_PDF_SETTING.ON : Constant.SPLIT_PDF_SETTING.OFF); setIsChangeData(true)}  
                                        }
                                    />
                                    <label htmlFor='pdf_split'></label>
                                </div>
                            </div>
                        </div> }
                    </>
                )}
                        <div className="accordionForm accordionForm--show" id="add-form-list-field-in-form">
                            <div className={isFormReadOnly ? "accordionHead pointer-default" : "accordionHead"} onClick={e=>{ handleOnclickListField('add-form-list-field-in-form')}}>
                                <span className="accordionHead-item">
                                    <img src="/assets/image/icon-pin.svg" alt="" />
                                </span>
                                <span className="accordionHead-text">
                                    {`以下のフィールドは使用する (${handleHiddenSysField(listFieldAddToForm, props.formEdit.type).length})`}
                                </span>
                            </div>
                            <div className="accordionContent">
                            {!isFormReadOnly && <div className="addField" id="addField-menu">
                            {/* Khi click vào 'div addField-accordion' thì 'div addField sẽ add addField--show' */}
                            <div className="addField-accordion">
                                <span onClick={onClickAddField}>フィールドを追加</span>
                            </div>
                            <div className="addField-content">
                                <p className="fieldType">フィールドタイプを選択</p>
                                <ul>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item" onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.TAG)}>
                                                <img src="/assets/image/icon-field.svg" alt="" />
                                            </span>
                                            <span className="addField-text">{I18n.get('TAG_TITLE')}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item" onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.DATE)}>
                                                <img src="/assets/image/icon-field01.svg" alt="" />
                                            </span>
                                            <span className="addField-text">時間</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item" onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.TEXT)}>
                                                <img src="/assets/image/icon-field02.svg" alt="" />
                                            </span>
                                            <span className="addField-text">テキスト</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item" onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.NUMBER)}>
                                                <img src="/assets/image/icon-field03.svg" alt="" />
                                            </span>
                                            <span className="addField-text">数字</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item" onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.IFRAME)}>
                                                <img src="/assets/image/icon-field05.svg" alt="" />
                                            </span>
                                            <span className="addField-text">iFrame</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item" onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.URL)}>
                                                <img src="/assets/image/icon-field06.svg" alt="" />
                                            </span>
                                            <span className="addField-text">URL</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item"  onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.FIELD_RICHTEXT)}>
                                                <img src="/assets/image/icon-field07.svg" alt="" />
                                            </span>
                                            <span className="addField-text">リッチテキスト</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item"  onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.MERMAID)}>
                                                <img src="/assets/image/mermaid-icon.svg" alt="" />
                                            </span>
                                            <span className="addField-text">{I18n.get('MERMAID')}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="addField-info">
                                            <span className="addField-item"  onClick={e => onClickFieldTypeSelected(Constant.FIELD_UI.HTML)}>
                                                <img src="/assets/image/html-icon.svg" alt="" />
                                            </span>
                                            <span className="addField-text">{I18n.get('HTML')}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>}

                                <div className="formTag">
                                    <DragDropContext
                                        onDragEnd={e => onDragEndHandler(e, argsAll)}
                                        onBeforeDragStart={e =>
                                            onBeforeDragStartHandler(e, argsAll)
                                        }
                                    >
                                        <Droppable droppableId="droppable">
                                            {(provided, snapshot) => (
                                                <ul
                                                    className="list-field-ul"
                                                    {...provided.droppableProps}
                                                    ref={provided.innerRef}
                                                >
                                                    {handleHiddenSysField(getDragDropList(), props.formEdit.type).map((item, index) => (
                                                        <Draggable
                                                            key={item.id}
                                                            draggableId={`${item.id}`}
                                                            index={item.indexInList ? item.indexInList : index}
                                                            isDragDisabled={isFormReadOnly}
                                                        >
                                                            {(childProvided, childSnapshot) => {
                                                                if (childSnapshot.isDragging) {
                                                                    childProvided.draggableProps.style.left =
                                                                        'auto!important';
                                                                }
                                                                return (
                                                                    <div
                                                                        ref={childProvided.innerRef}
                                                                        {...childProvided.draggableProps}
                                                                        {...childProvided.dragHandleProps}
                                                                        className="activeField"
                                                                    >
                                                                        {item.isShowInfo &&
                                                                            getAddFieldByFieldType(
                                                                                argsAll,
                                                                                item
                                                                            )}
                                                                        {!item.isShowInfo && (
                                                                            <li className={item.definition === Constant.FORM_DEFINITION.SYSTEM || 
                                                                            isUseFieldInForm(item, props.listForm, argsAll) ?
                                                                             "list-field-li listField-li" : " list-field-li listField-li background-color-usingForm"}>
                                                                                {renderFieldListV2(
                                                                                    item,
                                                                                    index,
                                                                                    'listFieldAddToForm'
                                                                                )}
                                                                            </li>
                                                                        )}
                                                                    </div>
                                                                );
                                                            }}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </ul>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                </div>
                            </div>
                        </div>
                        <div className="accordionForm" id="add-form-list-field-in-project">
                        {!isFormReadOnly && <><div className="accordionHead" onClick={e=> handleOnclickListField('add-form-list-field-in-project')}>
                            <span className="accordionHead-item">
                                <img src="/assets/image/icon-pin-outline.svg" alt="" />
                            </span>
                            <span className="accordionHead-text">
                                {`以下のフィールドは使用しない (${handleHiddenSysField(listFieldInProject, props.formEdit.type).length})`}
                            </span>
                        </div>
                        <div className="accordionContent">
                            <div className="formTag">
                                <ul>
                                {handleHiddenSysField(sortListFieldInProject(listFieldInProject), props.formEdit.type).map((item, index) => (
                                            <div className="activeField" key={item?.id || index}>
                                                {item.isShowInfo && getAddFieldByFieldType(argsAll, item)}
                                                {!item.isShowInfo && (
                                                    <li className={
                                                        item.definition === Constant.FORM_DEFINITION.SYSTEM ||
                                                        isUseFieldInForm(item, props.listForm, argsAll)
                                                        ? "list-field-li listField-li": " list-field-li listField-li background-color-usingForm"}>
                                                        {renderFieldListV2(item, index, 'listFieldInProject')}
                                                    </li>
                                                )}
                                            </div>
                                    ))}
                                </ul>
                            </div>
                        </div></>}
                        </div>
                    </div>
                    {/* render add field */}

                    {/* confirm dialog */}
                    <UnsavedChangesDialog
                        isOpen={props?.isOpenUnsavedChangesDialog}
                        messageConfirm={
                            formPanelTabClose.isClosePanel
                                ? I18n.get('MSG-CONFIRM-CLOSE-PANEL')
                                : I18n.get('MSG-CM-CONFIRM-CANCEL-FORM-FIELD-CHANGE')
                        }
                        closeCallBack={() => {
                            props?.setIsOpenUnsavedChangesDialog(false);
                            setFormPanelTabClose({
                                isDirty: false,
                                isClosePanel: false,
                                isCloseScreen: false,
                            });
                            if (formPanelTabClose.isClosePanel) {
                                closePanelFormManagement({panelList, setPanelList, currentIndex, setCurrentIndex});
                                return;
                            }
                            if (formPanelTabClose.isCloseScreen) {
                                if (isDuplicateForm && formEdit.isShared) {
                                    let cloneFieldListInState = cloneDeep(fieldListInState);
                                    cloneFieldListInState = cloneFieldListInState.filter(
                                        field =>
                                            ![
                                                Constant.CLIENT_FIELD_TYPE.ADD_NEW_FIELD,
                                                Constant.CLIENT_FIELD_TYPE.DUPLICATE_FIELD
                                            ].includes(field.clientFieldType)
                                    );
                                    setFieldListInState(cloneFieldListInState);
                                }
                                props.setOpenScreen(Constant.FORM_MANAGEMENT_SCREEN.LIST_FORM);
                                props.setIsDuplicateForm(false);
                                return;
                            }
                            props?.setTabSelected(Constant.TAB_FORM_MANAGEMENT.FIELD);
                        }}
                        closeBtnText={I18n.get('OK')}
                        cancelCallBack={() => {
                            props?.setIsOpenUnsavedChangesDialog(false);
                            setFormPanelTabClose(prev => ({
                                ...prev,
                                isClosePanel: false,
                                isCloseScreen: false,
                            }));
                        }}
                        cancelBtnText={I18n.get('CANCEL')}
                    />
                </div>
            )}
            {panelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_TAG_ITEM && (
                <div className="add-field-tag-frame">
                   <AddFieldTagItem {...{...argsAll,setIsLoading: props.setIsLoading}}/>
                </div>
            )}
            {panelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_STATUS_ITEM && (
                <div className="add-field-status-frame">
                    <AddFieldStatusItem {...argsAll} />
                </div>
            )}

        </>
    );
}
